import { render } from "./BookmarkModal.vue?vue&type=template&id=26ea87e6&scoped=true"
import script from "./BookmarkModal.vue?vue&type=script&lang=js"
export * from "./BookmarkModal.vue?vue&type=script&lang=js"

import "./BookmarkModal.vue?vue&type=style&index=0&id=26ea87e6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26ea87e6"]])

export default __exports__